/**
 * ExpansionPanel component
 *
 * Used to render generic content within an accordion panel.
 *
 * <ng-content> tag in the template enables any content to be encapsulated
 * in an expansion panel component.
 */

import { Component, Input, OnInit } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  standalone: true,
  imports: [AccordionModule],
})
export class ExpansionPanelComponent {
  // Title to display on the expansion panel
  @Input() title = '';
  @Input() value = '0';
}
